import { BehaviorSubject, interval } from 'rxjs';

import { EntityModel, LineModel, Plane2Model } from './model';

import { Vector3, Vector2 } from 'three';

import { BoundingBox2FromCenterSize } from './share/boundingbox2';

export const TEST_MODELS: { id: string; model: EntityModel }[] = [
  {
    id: 'testLine',
    model: new LineModel(new Vector3(0, 0, 0), new Vector3(40, 0, 0)),
  },
  {
    id: 'testPlane',
    model: new Plane2Model(
      new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(10, 10)),
      10,
      {
        r: new Uint8Array([255]),
        g: new Uint8Array([255]),
        b: new Uint8Array([255]),
        shape: new Vector2(1, 1),
      },
    ),
  },
  {
    id: 'testImage',
    model: new Plane2Model(
      new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(10, 10)),
      10,
      {
        r: new Uint8Array([255]),
        g: new Uint8Array([255]),
        b: new Uint8Array([255]),
        shape: new Vector2(1, 1),
      },
    ),
  },
];

function sequencePlane() {
  const result = new BehaviorSubject<Plane2Model>(randomPlane());
  interval(10000).subscribe({
    next: () => result.next(randomPlane()),
    error: e => console.log(e),
  });
  // result.next(randomPlane());

  return result;
}

function randomPlane() {
  const pixels = [1, 2, 3, 4, 5, 6];
  return new Plane2Model(
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(10, 20)),
    10,
    {
      r: new Uint8Array(pixels.map(() => Math.random() * 255)),
      g: new Uint8Array(pixels.map(() => Math.random() * 255)),
      b: new Uint8Array(pixels.map(() => Math.random() * 255)),
      shape: new Vector2(3, 3),
    },
  );
}
